export default "__VITE_ASSET__DcMXqfbK__"